// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.search-overlay{height:100%;width:100%}.search-overlay__close{display:block;margin-left:auto;padding:5px;transform:translateY(clamp(1.5625rem,1.16rem + 1.34vw,2.5rem));z-index:1}@media(min-width:768px){.search-overlay__close{position:sticky;top:0;transform:translate(50%,clamp(1.5625rem,1.16rem + 1.34vw,2.5rem))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
